import React, {Component} from 'react'
import PropTypes from "prop-types"
import moment from "moment"

class ColDateCreated extends Component {
    render() {
        const {created} = this.props
        const textTime = created ? moment(created).format('HH:mm DD/MM/YYYY') : '-'

        return <td className="colDate">
            {textTime}
        </td>
    }
}

ColDateCreated.propTypes = {
    created: PropTypes.string.isRequired
}

export default ColDateCreated